// This icon file is generated automatically.
var PSmallDashOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M.75 6.44h1.13v1.12H.75V6.44zm2.84 0h1.13v1.12H3.59V6.44zm5.7 0h1.12v1.12H9.28V6.44zm2.84 0h1.12v1.12h-1.13V6.44zm-5.7 0h1.13v1.12H6.44V6.44z", "fill-rule": "nonzero" } }] }, "name": "p-small-dash", "theme": "outlined" };
export default PSmallDashOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSmallDashOutlined.js
// module id = 3643
// module chunks = 0